module.exports = __webpack_public_path__ + "media/images/landing_page/13_mobile-362e538c7100bcda414fa28d856ad1a9.webp";